/** Minimum squared radius for circle inversion (`max(dot(p,p), eps)`). */
export const UV_WARP_CIRCLE_INVERSION_EPS_SQ = 1e-4;
